import { projectCategory } from "../constants/categories";

export function mergeAndSum(expenses: any, tasks: any): { statistic: any[] } {
  // Defensive, return empty if no data
  const result: Record<string, any> = {};
  const PH_KEY = 'category_public_holidays';

  const isPH = (project: any) => {
    if (!project) return false;
    const name = project.name ?? '';
    const desc = (project.description ?? '').toLowerCase();
    if (projectCategory[name] === 'public_holidays') return true;
    if (name.includes('61xG090')) return true;
    if (desc.includes('public holidays')) return true;
    return false;
  };

  const ensure = (id: string | number, proj: any) => {
    if (!result[id]) {
      result[id] = {
        project: proj,
        expense: { sum: 0, percent: 0 },
        task: { hours: 0, percent: 0 }
      };
    }
  };

  // Expenses
  if (Array.isArray(expenses)) {
    for (const exp of expenses) {
      let projectId = exp?.project?.id ?? 'unknown';
      let projObj = exp?.project ?? { id: projectId, name: '', description: '' };

      if (isPH(projObj) || exp?.category === 'public_holidays') {
        projectId = PH_KEY;
        projObj = { id: PH_KEY, name: '61xG090', description: 'Public Holidays' };
      }

      ensure(projectId, projObj);
      result[projectId].expense.sum += exp?.sum ?? 0;
      result[projectId].expense.percent += exp?.percent ?? 0;
    }
  }

  // Tasks
  if (Array.isArray(tasks)) {
    for (const task of tasks) {
      let projectId = task?.project?.id ?? 'unknown';
      let projObj = task?.project ?? { id: projectId, name: '', description: '' };

      if (task?.category === 'public_holidays' || (!task?.category && isPH(projObj))) {
        projectId = PH_KEY;
        projObj = { id: PH_KEY, name: '61xG090', description: 'Public Holidays' };
      }

      ensure(projectId, projObj);
      result[projectId].task.hours += task?.hours ?? 0;
      result[projectId].task.percent += task?.percent ?? 0;
    }
  }

  return { statistic: Object.values(result) };
}